import { render, staticRenderFns } from "./QuoteWide.vue?vue&type=template&id=c3b5fd86&scoped=true"
import script from "./QuoteWide.vue?vue&type=script&lang=js"
export * from "./QuoteWide.vue?vue&type=script&lang=js"
import style0 from "./QuoteWide.vue?vue&type=style&index=0&id=c3b5fd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b5fd86",
  null
  
)

export default component.exports